<template>
  <transition name="fade">
    <div class="slider-backdrop" v-if="openBackdrop">
      <transition name="slide">
        <div class="slider" v-show="openSlider">
          <div class="header">
            <span class="header-title">
              Notifications
              <span class="mdi mdi-bell"></span>
            </span>
            <pix-button @click.native="closeSidebar" :iconClass="'mdi-close'" />
          </div>
          <div>
            <div v-for="entry in notifications" :key="entry.date">
              <div class="notification-date">{{ dateAsText(entry.date) }}</div>
              <div class="notification" v-for="notification in entry.notifications" :key="notification.NotificationId">
                <span :class="{ 'notification-unread': notification.IsUnread, 'notification-read': !notification.IsUnread }"></span>
                <pix-member-circle-row :names="[notification.FromUserId]" />
                <div class="notification-name">
                  {{ asUsername(notification.FromUserId) }}
                </div>
                <div>
                  {{ notification.NotificationDescription }}
                </div>
                <div class="buttons-and-time">
                  <pix-button v-show="notification.IsUnread" :iconClass="'mdi-email-open'" @click="setNotificationRead(notification.NotificationId)" />
                  <pix-button v-show="!notification.IsUnread" :iconClass="'mdi-email'" @click="setNotificationUnread(notification.NotificationId)" />
                  <pix-button v-show="!notification.IsUnread" :iconClass="'mdi-delete'" @click="deleteNotification(notification.NotificationId)" />
                  <div class="time">{{ asTime(notification.NotificationDate) }}</div>
                </div>
              </div>
            </div>
            <div v-show="showSpinner" ref="notificationsSpinner" class="spinner"></div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import pixButton from 'pix-button';
//TODO CHANGE RELATIVE IMPORT
import pixMemberCircleRow from '@/components/pix/pixMemberCircleRow.vue';

export default {
  name: 'pix-sidebar',
  // props: {},

  components: {
    pixButton,
    pixMemberCircleRow,
  },
  data() {
    return {
      openBackdrop: false,
      openSlider: false,
    };
  },
  mounted() {
    this.startFetchingNotifications();
  },
  watch: {
    openBackdrop() {
      setTimeout(() => {
        const spinnerEl = this.$refs.notificationsSpinner;

        if (!spinnerEl) {
          return;
        }

        let prevRatio = 0;
        const handleIntersect = ((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio > prevRatio) {
              this.fetchNotifications();
            }
            prevRatio = entry.intersectionRatio;
          });
        }).bind(this);

        const options = {
          root: null,
          rootMargin: '0px',
          threshold: [0.1],
        };

        const observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(spinnerEl);
      }, 0);
    },
    showMenu(newValue) {
      // This is due to Vue not detecting two transitions at different times
      // this forces one to be before the other and makes both animations to display correctly
      // don't reuse this code, try css
      if (newValue) {
        this.openBackdrop = true;
        setTimeout(() => {
          this.openSlider = true;
        }, 0);
      } else {
        this.openSlider = false;
        setTimeout(() => {
          this.openBackdrop = false;
        }, 0);
      }
    },
  },
  computed: {
    ...mapGetters('notificationsModule', { notificationsLong: 'getOrderedNotifications', showMenu: 'getOpenMenu', notificationsArr: 'getNotifications', totalNotifications: 'getTotalNotifications' }),

    notifications() {
      return this.notificationsLong.reduce((prevDates, date) => [...prevDates, date], []);
    },

    showSpinner() {
      return this.notificationsArr.length < this.totalNotifications;
    },
  },
  methods: {
    ...mapActions('notificationsModule', ['setNotificationRead', 'setNotificationUnread', 'deleteNotification', 'startFetchingNotifications', 'fetchNotifications']),

    closeSidebar() {
      this.$store.dispatch('notificationsModule/setOpenMenu', false);
    },

    dateAsText(date) {
      // TODO get from configuration for i18n
      return moment(date).format('dddd, MMMM Do, YYYY');
    },
    asTime(date) {
      // TODO get from configuration for i18n
      // we can safely assume that backend gives us a date in utc, append the Z so that moment understands this.
      return moment(`${date}Z`).format('LT');
    },
    asUsername(email) {
      const [userName, userSurname] = email.split('@')?.[0].split('.');
      return `${userName ?? ''} ${userSurname ?? ''}`;
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
/* TODO */
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slider-backdrop {
  /* top: 50px; */
  left: 0;
  position: fixed;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgb(0 0 0 / 50%);
  pointer-events: none;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s;
}
/* TODO */
.slide-enter,
.slide-leave-to {
  transform: translateX(100px);
}

.slider {
  position: fixed;
  background-color: white;
  top: 50px;
  height: calc(100vh - 50px);
  pointer-events: all;
  box-shadow: rgb(0 0 0 / 50%) 1px 1px 20px;
  overflow: auto;
  right: 0;
  z-index: 1000;
  width: 500px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #929292;
  color: white;
  height: 42px;
}

.content {
  display: flex;
  flex-flow: column;
}

.notification-date {
  border-bottom: solid 1px #c5c5c7;
  color: #404040;
  padding-left: 20px;
}

.notification-name {
  font-weight: bold;
}

.notification {
  border-bottom: solid 1px #c5c5c7;
  color: #404040;
  font-size: 14px;
  padding-left: 30px;

  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 2fr 4fr 14fr 4fr;
  align-items: center;
  text-align: center;
}

.header-title {
  padding-left: 16px;
}

.buttons-and-time {
  display: grid;
  grid-template: 1fr 1fr / 1fr 1fr;
}

.time {
  grid-area: 2/1 / 2/3;
}

.header >>> .pix-button_icon {
  color: white;
}

.buttons-and-time >>> .pix-button_icon {
  color: #929292;
}

.notification-unread {
  width: 6px;
  height: 6px;
  background-color: #00bcff;
  border-radius: 50%;
}

.notification-read {
  width: 6px;
  height: 6px;
}

.spinner,
.spinner:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.spinner {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border: 1.1em solid rgba(180, 180, 180, 0.8);
  border-left: 1.1em solid #ffffff;
  transform: translateZ(0);
  animation: spin 1.1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
